interface StickyWhatsAppProps {
  onOpenApprovalModal: () => void;
}

export default function StickyWhatsApp({ onOpenApprovalModal }: StickyWhatsAppProps) {
  return (
    <button
      type="button"
      onClick={onOpenApprovalModal}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-5 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm shadow-lg hover:bg-accent-600 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
      aria-label="WhatsApp'tan Uygundur Yaz"
    >
      <i className="ri-whatsapp-line text-xl"></i>
      <span className="hidden sm:inline">Uygundur Yaz</span>
    </button>
  );
}